import React, { useEffect, useState, useRef } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ImageWithBasePath from '../../core/img/imagewithbasebath';
import { ChevronUp } from 'feather-icons-react/build/IconComponents';
import { useDispatch, useSelector } from 'react-redux';
import { setToogleHeader } from '../../core/redux/action';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import Table from '../../core/pagination/datatable'
import { getAllProducts, deleteProduct } from '../../services/mainService';
import Loader from '../loader/loader';
import { useToast } from '../../Toaster/ToastContext';

const LowStock = () => {

    const dispatch = useDispatch();
    const data = useSelector((state) => state.toggle_header);
    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState([]);
    const [activeTab, setActiveTab] = useState('low-stock');
    const isDeleting = useRef(false);
    const { showToast } = useToast();

    const fetchlowStockProducts = async () => {
        try {
            setLoading(true);
            const response = await getAllProducts();
            const productsData = response.data;
            setProducts(productsData);
        } catch (error) {
            console.error('Error fetching products:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchlowStockProducts();
    }, []);

    const renderCollapseTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>
            Collapse
        </Tooltip>
    );

    const getFilteredProducts = () => {
        const currentDate = new Date();
        return products.filter(product => {
            const expiryDate = new Date(product.expiry_on);
            const isNotExpired = expiryDate > currentDate;
            
            if (activeTab === 'low-stock') {
                return isNotExpired && product.quantity > 0 && product.quantity < 5;
            } else {
                return isNotExpired && product.quantity === 0;
            }
        });
    };

    const columns = [
        {
            title: "Branch",
            dataIndex: "branch_name",
            render: (text) => text || "N/A",
            sorter: (a, b) => (a.branch_name || "").localeCompare(b.branch_name || ""),
            width: "5%"
        },
        {
            title: "Product",
            dataIndex: "name",
            render: (text, record) => (
                <span className="productimgname">
                    {record.image && record.image.length > 0 && (
                        <Link to="#" className="product-img stock-img">
                            <ImageWithBasePath alt="" src={record.image[0]} />
                        </Link>
                    )}
                    {text}
                </span>
            ),
            sorter: (a, b) => a.name.localeCompare(b.name),
        },
        {
            title: "Category",
            dataIndex: "category_name",
            render: (text) => text || "N/A",
            sorter: (a, b) => (a.category_name || "").localeCompare(b.category_name || ""),
        },
        {
            title: "Price",
            dataIndex: "price",
            sorter: (a, b) => parseFloat(a.price) - parseFloat(b.price),
        },
        {
            title: "Quantity",
            dataIndex: "quantity",
            sorter: (a, b) => a.quantity - b.quantity,
        },
        {
            title: 'Action',
            dataIndex: 'actions',
            key: 'actions',
            render: (_, record) => (
                <td className="action-table-data">
                    <div className="edit-delete-action">
                        <Link className="confirm-text p-2" to="#"  >
                            <i data-feather="trash-2" className="feather-trash-2" onClick={() => showConfirmationAlert(record)}></i>
                        </Link>
                    </div>
                </td>
            )
        },
    ];
    const MySwal = withReactContent(Swal);

    const showConfirmationAlert = (record) => {
        MySwal.fire({
            title: 'Are you sure?',
            text: 'You won\'t be able to revert this!',
            showCancelButton: true,
            confirmButtonColor: '#00ff00',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonColor: '#ff0000',
            cancelButtonText: 'Cancel',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    setLoading(true);
                    isDeleting.current = true;
                    const response = await deleteProduct(record.id);
                    const data = await response.json();
                    if (data.success) {
                        showToast('Product deleted successfully', 'success', 'Product Operation!');
                        await fetchlowStockProducts();
                    } else {
                        showToast(data.message || 'Failed to delete product', 'error', 'Product Operation!');
                    }
                } catch (error) {
                    showToast(error.message || 'Failed to delete product', 'error', 'Product Operation!');
                } finally {
                    setLoading(false);
                    isDeleting.current = false;
                }
            } else {
                MySwal.close();
            }

        });
    };


    return (
        <div>
            <Loader loading={loading} />
            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header">
                        <div className="page-title me-auto">
                            <h4>Low Stocks</h4>
                            <h6>Manage your low stocks</h6>
                        </div>
                        <ul className="table-top-head">
                            {/* <li>
                                <div className="status-toggle d-flex justify-content-between align-items-center">
                                    <input type="checkbox" id="user2" className="check" defaultChecked="true" />
                                    <label htmlFor="user2" className="checktoggle">
                                        checkbox
                                    </label>
                                    Notify
                                </div>
                            </li> */}
                            <li>
                                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                                    <Link
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        id="collapse-header"
                                        className={data ? "active" : ""}
                                        onClick={() => { dispatch(setToogleHeader(!data)) }}
                                    >
                                        <ChevronUp />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                        </ul>
                    </div>
                    <div className="table-tab">
                        <ul className="nav nav-pills" id="pills-tab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button
                                    className={`nav-link ${activeTab === 'low-stock' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('low-stock')}
                                    type="button"
                                    role="tab"
                                >
                                    Low Stocks
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button
                                    className={`nav-link ${activeTab === 'out-of-stock' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('out-of-stock')}
                                    type="button"
                                    role="tab"
                                >
                                    Out of Stocks
                                </button>
                            </li>
                        </ul>
                        <div className="tab-content" id="pills-tabContent">
                            <div className="tab-pane fade show active">
                                <div className="card table-list-card">
                                    <div className="card-body">
                                        <div className="table-top">
                                            <div className="search-set">
                                                <div className="search-input">
                                                    <input
                                                        type="text"
                                                        placeholder="Search"
                                                        className="form-control form-control-sm formsearch"
                                                    />
                                                    <Link to className="btn btn-searchset">
                                                        <i data-feather="search" className="feather-search" />
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="table-responsive">
                                            <Table columns={columns} dataSource={getFilteredProducts()} rowSelection = {null} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LowStock;
